<template>
  <div class="p-conversation">
    <div class="g-header">
      <el-page-header @back="back">
        <div slot="content">{{ info.company }} - {{ info.name }}</div>
        <div slot="title">
          <i class="el-icon-arrow-left"></i>
          返回
        </div>
      </el-page-header>
    </div>
    <div class="scroll-body">
      <ul class="infinite-list" ref="messageList" style="overflow:auto">
        <li ref="message" v-for="item in messageList" :key="item.msgId">
          <bubble-message :info="item"></bubble-message>
        </li>
      </ul>
    </div>
    <div class="g-footer">
      <edit-box :is-private="true" @send="sendMessage"></edit-box>
    </div>
    <div class="scroll-tip">
      <el-button v-if="!inBottom" @click="scrollBottom" size="small" style="color: #67C23A"> <i class="el-icon-download"></i>回到最新位置 </el-button>
    </div>
  </div>
</template>
<script>
import EditBox from "@/components/EditBox";
import BubbleMessage from "@/components/BubbleMessage";
import { mapState } from "vuex";
import Bus from "@/components/Bus";
export default {
  data() {
    return {
      inBottom: true,
      conversationId: "",
      loading: false,
      pageSize: 10
    };
  },
  computed: {
    ...mapState({
      privateChat(state) {
        return state.privateChat;
      },
      pageIndex: state => state.privateChat.pageIndex,
      totalCount: state => state.privateChat.totalCount,
      isHubInit: state => state.isHubInit,
      messageList: state => state.privateChat.messageList,
      info: state => state.privateChat.info
    })
  },
  components: { EditBox, BubbleMessage },
  watch: {
    // 外部创建连接完成后初始化
    isHubInit: {
      immediate: true,
      handler(value) {
        if (value === true) {
          this.$nextTick(() => {
            this.$store.dispatch("getLastChatRecords", {
              conversationId: this.conversationId,
              pageIndex: 1
            });
          });
        }
      }
    },
    messageList() {
      if (this.inBottom) {
        this.$nextTick(() => this.scrollBottom());
      }
    }
  },
  methods: {
    // 返回时清空私聊消息，更新未读消息
    async back() {
      await $.connection.chatConversationHub.server.setRead(this.conversationId);
      this.$store.commit("setPrivateChat", {});
      Bus.$emit("getConversations");
      this.$router.push({ path: "/" });
    },
    scrollBottom() {
      window.scrollTo(0, document.body.scrollHeight);
    },
    sendMessage(e) {
      $.connection.chatConversationHub.server.send({
        conversationId: this.conversationId,
        imgs: e.imgs,
        toUserId: this.info.userId,
        txt: e.txt
      });
    },
    // 获取更多消息
    async more() {
      this.loading = true;
      this.$store.dispatch("getLastChatRecords", {
        conversationId: this.conversationId,
        pageIndex: this.pageIndex + 1
        // lastMsgId: this.privateChat.messageList[0].msgId
      });
      this.loading = false;
    },
    scrollHandle() {
      const scrollTop = $(document).scrollTop();
      const scrollHeight = $(document).height();
      // 滚动条超过三分一时显示最新消息
      this.inBottom = scrollHeight - scrollTop <= 1200;
      if (this.totalCount <= this.messageList.length) {
        return false;
      }
      if (scrollTop < 300) {
        if (this.loading === true) {
          return false;
        }
        this.more();
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollHandle, true);
  },
  created() {
    const { id } = this.$route.query;
    this.conversationId = id;
    this.$store.commit("setPrivateChat", this.$route.query);
  },
  mounted() {
    document.addEventListener("scroll", this.scrollHandle, true);
  }
};
</script>
<style lang="scss">
.p-conversation {
  background-color: #f0f3f8;
  .g-header {
    .bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 5px 0 10px;
      height: 32px;
      background-color: #5e5e5e;
      .prepend {
        display: flex;
        align-items: center;

        span {
          display: inline-flex;
          align-items: center;
          line-height: 16px;
          font-size: 12px;
        }
      }

      .user {
        cursor: pointer;
        color: #fff;
      }
    }
    .tab-bar {
      display: flex;
      padding-right: 5px;
      justify-content: space-between;
      align-items: center;
    }
  }
  .infinite-list {
    padding: 0 10px;
  }
  .scroll-body {
    padding-top: 40px;
    padding-bottom: 90px;
    position: relative;
    min-height: 100vh;
    overflow: auto;
  }
}
</style>
